"use client";

import { useState } from "react";
import { Headphones, Minus, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
const faqs = [{
  id: "faq-1",
  question: "How does HotelRevBaBa improve OTA performance?",
  answer: "We optimize your property's presence on OTAs by refining content, managing rate parity, and leveraging data-driven pricing strategies to increase visibility and conversion rates across all major booking platforms."
}, {
  id: "faq-2",
  question: "What hospitality tech stacks do you recommend?",
  answer: "We evaluate your current infrastructure and recommend integrated PMS, Channel Manager, and RMS solutions that streamline operations, reduce manual workload, and provide actionable insights for revenue growth."
}, {
  id: "faq-3",
  question: "What is included in a revenue audit?",
  answer: "Our comprehensive revenue audit covers a deep dive into your historical booking data, competitor benchmarking, pricing strategy effectiveness, and distribution channel health to identify untapped revenue opportunities."
}, {
  id: "faq-4",
  question: "How do you ensure data-driven results?",
  answer: "We utilize advanced analytics to monitor market demand, booking pace, and competitor behavior, allowing us to adjust your pricing and distribution strategies in real-time for maximum profitability."
}, {
  id: "faq-5",
  question: "Can I get a custom revenue management plan?",
  answer: "Absolutely. We tailor our consulting services to the unique needs of your property, whether you are a boutique hotel, a large resort, or an independent property investor looking to scale revenue."
}];
export default function Consultancyfaq() {
  const [openId, setOpenId] = useState<string | null>("faq-1");
  const toggle = (id: string) => {
    setOpenId(prev => prev === id ? null : id);
  };
  return <section data-section-id="1945" id="consultancyfaq" className="bg-slate-50 text-slate-900 py-20 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl rounded-lg bg-white p-6 sm:p-10 lg:p-14 shadow-md">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <p className="font-default text-xs uppercase tracking-widest text-blue-700">
                Expert Insights
              </p>
              <h2 className="mt-4 font-default text-4xl sm:text-5xl font-bold uppercase tracking-tight">
                Revenue Strategy FAQ
              </h2>
              <p className="mt-5 font-default text-base text-slate-600 max-w-sm">
                Get answers to common questions about our revenue management consulting, OTA strategies, and hospitality technology implementation.
              </p>
              <Link to="/ContactPage" className="mt-7 inline-flex items-center gap-2 rounded-lg border border-slate-200 px-5 py-2.5 font-default text-sm font-medium text-slate-900 transition-colors hover:border-blue-600 hover:text-blue-700">
                <Headphones className="size-4" />
                Contact Our Team
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="border-t border-slate-200">
              {faqs.map((faq, i) => {
              const isOpen = openId === faq.id;
              return <div key={faq.id} data-index={i} className="border-b border-slate-200">
                    <button type="button" onClick={() => toggle(faq.id)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left">
                      <span className={`font-default text-lg sm:text-xl font-bold tracking-tight transition-colors ${isOpen ? "text-blue-700" : "text-slate-900"}`}>
                        {faq.question}
                      </span>
                      <span className={`flex size-9 shrink-0 items-center justify-center rounded-lg border transition-all duration-300 ${isOpen ? "border-blue-600 text-blue-700 rotate-180" : "border-slate-200 text-slate-400"}`}>
                        {isOpen ? <Minus className="size-4" /> : <Plus className="size-4" />}
                      </span>
                    </button>
                    <div className={`grid overflow-hidden transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="pb-6 pr-12 font-default text-base text-slate-600">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}